import { render, staticRenderFns } from "./ThemeColorConfig.vue?vue&type=template&id=9b81bbc4&scoped=true"
import script from "./ThemeColorConfig.vue?vue&type=script&lang=js"
export * from "./ThemeColorConfig.vue?vue&type=script&lang=js"
import style0 from "./ThemeColorConfig.vue?vue&type=style&index=0&id=9b81bbc4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b81bbc4",
  null
  
)

export default component.exports